import { Box, Typography } from '@mui/material'
import { useContext, useEffect } from 'react'
import { SetBreadcrumbContext } from '../../../contextProviders/BreadcrumbProvider'
import { generatePath, useNavigate } from 'react-router'
import { AppRoutes } from '../../Routes'
import { RCNSelection } from './RCNSelection'
import type { OrganizationOption } from '../../../models/requestObjects/CommonObjects'
import { useAuth } from '../../../hooks/use-auth'
import { SecurityLevel } from '../../../utils/genericTypes'
import { GetRcnFromOrganization } from '../../../services/OrganizationService'

export function Planning (): JSX.Element {
  const nav = useNavigate()
  const setBreadcrumbs = useContext(SetBreadcrumbContext)
  const { user } = useAuth()

  // Select RCN based on current selected org for RCN and ISD users
  useEffect(() => {
    if (user == null) return

    const navigateToRcn = async (): Promise<void> => {
      const rcn = await GetRcnFromOrganization(user.currentOrgId)
      await handleRcnSelected(rcn)
    }

    if (![SecurityLevel.ProjectAdmin, SecurityLevel.ProjectUser].includes(user.securityLevel)) {
      void navigateToRcn()
    }
  }, [user])

  const handleRcnSelected = async (rcn: OrganizationOption): Promise<void> => {
    if (user == null) return

    if (![SecurityLevel.ProjectAdmin, SecurityLevel.ProjectUser].includes(user.securityLevel)) {
      setBreadcrumbs([{ name: 'Home', route: generatePath(AppRoutes.HOME) }])
    } else {
      setBreadcrumbs([{ name: 'RCNs', route: generatePath(AppRoutes.PLANNING) }])
    }

    const detailsRoute = generatePath(
      AppRoutes.PLANNING_INSTANCE,
      { rcnId: rcn.id.toString() }
    )
    nav(detailsRoute)
  }

  return (
    <Box data-testid='planning' sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: '12px'
    }}
    >
      <Typography variant='h1' data-testid='pageHeader'>Annual Planning</Typography>

      <RCNSelection onRCNSelect={handleRcnSelected} isImplementationPhase={false} />
    </Box>
  )
}
